export const SECTION_COLORS = [
  'emerald',
  'blue',
  'violet',
  'amber',
  'rose',
  'cyan',
];

export function createSectionId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `sec-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export function makeEmptySection(index) {
  return {
    id: createSectionId(),
    title: `Section ${index + 1}`,
    color: SECTION_COLORS[index % SECTION_COLORS.length],
    topics: [],
  };
}

/** Normalize API / persisted JSON into builder shape */
export function normalizeCurriculumOutline(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .filter((s) => s && typeof s === 'object')
    .map((s, i) => ({
      id: String(s.id ?? createSectionId()),
      title: typeof s.title === 'string' ? s.title : `Section ${i + 1}`,
      color:
        typeof s.color === 'string' && SECTION_COLORS.includes(s.color)
          ? s.color
          : SECTION_COLORS[i % SECTION_COLORS.length],
      topics: Array.isArray(s.topics) ? s.topics.map((t) => String(t ?? '')) : [],
    }));
}
